module.exports = __webpack_public_path__ + "img/14_37.21ffa1c2.png";